import React from 'react';
import vennvaLogo from '../assets/img/vennva.png';

const Products = () => {
  // Brands that trust us
  const trustedBrands = [
    {
      name: 'Ecomart.ng',
      logo: 'https://ecomart.ng/static/media/logo.36c428530d8f25b5ee72.png',
      website: 'https://ecomart.ng'
    },
    {
      name: 'Diceace21.com',
      logo: 'https://diceace21.com/static/media/logo.00dfb361eb59d11c00a3.png',
      website: 'https://diceace21.com'
    },
    {
      name: 'Vennva.com',
      logo: vennvaLogo,
      website: 'https://vennva.com'
    },
    {
      name: 'Ecomart.ng',
      logo: 'https://ecomart.ng/static/media/logo.36c428530d8f25b5ee72.png',
      website: 'https://ecomart.ng'
    },
    {
      name: 'Diceace21.com',
      logo: 'https://diceace21.com/static/media/logo.00dfb361eb59d11c00a3.png',
      website: 'https://diceace21.com'
    },
    {
      name: 'Vennva.com',
      logo: vennvaLogo,
      website: 'https://vennva.com'
    }
  ];

  return (
    <section id="trusted-brands" className="py-16 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-sals-dark mb-4">
            Trusted By <span className="text-sals-primary">Leading Brands</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-sals-primary to-sals-light mx-auto rounded-full"></div>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Our partners who trust us to deliver exceptional results
          </p>
        </div>

        {/* Train Moving Logos */}
        <div className="relative">
          {/* Gradient overlays for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-gray-50 to-transparent z-10"></div>

          <div className="train-container">
            <div className="train-track">
              {/* First set of brands */}
              {trustedBrands.map((brand, index) => (
                <a
                  key={`first-${index}`}
                  href={brand.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="train-item"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="train-logo"
                  />
                  <span className="train-name">{brand.name}</span>
                </a>
              ))}
              {/* Duplicate set for seamless loop */}
              {trustedBrands.map((brand, index) => (
                <a
                  key={`second-${index}`}
                  href={brand.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="train-item"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="train-logo"
                  />
                  <span className="train-name">{brand.name}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Trust Badge */}
        {/* <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 px-6 py-3 bg-sals-primary/10 rounded-full">
            <span className="text-2xl">🚂</span>
            <span className="text-sals-dark font-semibold">
              Join our growing list of trusted partners
            </span>
          </div>
        </div> */}
      </div>

      <style jsx>{`
        .train-container {
          overflow: hidden;
          padding: 30px 0;
          position: relative;
        }

        .train-track {
          display: flex;
          animation: trainMove 30s linear infinite;
          gap: 50px;
          width: max-content;
          align-items: center;
        }

        .train-container:hover .train-track {
          animation-play-state: paused;
        }

        .train-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
          text-decoration: none;
          min-width: 150px;
          padding: 15px 20px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
        }

        .train-item:hover {
          transform: scale(1.08) translateY(-5px);
          box-shadow: 0 10px 30px rgba(79, 70, 229, 0.15);
          background: white;
        }

        .train-logo {
          height: 60px;
          width: auto;
          object-fit: contain;
          transition: all 0.3s ease;
        }

        .train-name {
          font-size: 0.75rem;
          color: #6B7280;
          font-weight: 600;
          text-align: center;
          transition: color 0.3s ease;
          letter-spacing: 0.5px;
        }

        .train-item:hover .train-name {
          color: #4F46E5;
        }

        @keyframes trainMove {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .train-track {
            gap: 30px;
            animation-duration: 25s;
          }
          
          .train-logo {
            height: 45px;
          }
          
          .train-item {
            min-width: 120px;
            padding: 12px 15px;
          }

          .train-name {
            font-size: 0.65rem;
          }
        }

        @media (max-width: 480px) {
          .train-track {
            gap: 20px;
            animation-duration: 20s;
          }
          
          .train-logo {
            height: 35px;
          }
          
          .train-item {
            min-width: 100px;
            padding: 10px 12px;
          }
        }
      `}</style>
    </section>
  );
};

export default Products;